window.k1DiscountTime = {
	getDiscountTime: function () {
		return document.getElementById('discount-time').value.toLocaleString()
	},
	getDiscountValue: function () {
		return document.getElementById('discount-value').value
	},
	getCurrentDate: function () {
		return new Date().toISOString();

	},
	getDifferentTime: function () {
		//todo проверить правильность получения максимальной скикди
		//header input#discount-time input#discount-value
		let diff = Date.parse(this.getDiscountTime()) - Date.parse(this.getCurrentDate());

		return {
			seconds: parseInt(diff / 1000 % 60),
			minutes: parseInt(diff / (1000 * 60) % 60),
			hours: parseInt(diff / (1000 * 60 * 60) % 24),
			days: parseInt(diff / (1000 * 60 * 60 * 24)),
		}


	},
	setDifferentTime: function () {
		if (document.querySelector('.drop-menu__couter')) {
			document.getElementById('discount-card-seconds').textContent = this.getDifferentTime().seconds;
			document.getElementById('discount-card-minutes').textContent = this.getDifferentTime().minutes;
			document.getElementById('discount-card-hours').textContent = this.getDifferentTime().hours;
			document.getElementById('discount-card-days').textContent = this.getDifferentTime().days;
		}
		// in mattress dropdown
		if (document.querySelector('.drop-menu__counter-mattress')) {
			document.getElementById('discount-card-mattress-seconds').textContent = this.getDifferentTime().seconds;
			document.getElementById('discount-card-mattress-minutes').textContent = this.getDifferentTime().minutes;
			document.getElementById('discount-card-mattress-hours').textContent = this.getDifferentTime().hours;
			document.getElementById('discount-card-mattress-days').textContent = this.getDifferentTime().days;
		}

		// in beds dropdown
		if (document.querySelector('.drop-menu__counter-beds')) {
			document.getElementById('discount-card-beds-seconds').textContent = this.getDifferentTime().seconds;
			document.getElementById('discount-card-beds-minutes').textContent = this.getDifferentTime().minutes;
			document.getElementById('discount-card-beds-hours').textContent = this.getDifferentTime().hours;
			document.getElementById('discount-card-beds-days').textContent = this.getDifferentTime().days;
		}

		//header times
		if (document.querySelector('.sale-up')) {
			document.getElementById('header-discount-seconds').textContent = this.getDifferentTime().seconds;
			document.getElementById('header-discount-minutes').textContent = this.getDifferentTime().minutes;
			document.getElementById('header-discount-hours').textContent = this.getDifferentTime().hours;
			document.getElementById('header-discount-days').textContent = this.getDifferentTime().days;
		}

		this.setDifferentSecondsDescription(this.getDifferentTime().seconds);
		this.setDifferentMinutesDescription(this.getDifferentTime().minutes);
		this.setDifferentHoursDescription(this.getDifferentTime().hours);
		this.setDifferentDaysDescription(this.getDifferentTime().days);
	},
	setDifferentSecondsDescription: function (CurSeconds) {
		let seconds = document.querySelectorAll('.discount-times-seconds');
		if (!seconds.length) return false;
		let description = '';
		if (+CurSeconds > 20) {
			let lastSymbol = CurSeconds.toString().slice(-1);
			switch (lastSymbol) {
				case '1':
					description = 'секунда';
					break;
				case '2':
				case '3':
				case '4':
					description = 'секунды';
					break;
				default:
					description = 'секунд';
					break;
			}

		} else {
			switch (CurSeconds) {
				case 1:
					description = 'секунда';
					break;
				case 2:
				case 3:
				case 4:
					description = 'секунды';
					break;
				default:
					description = 'секунд';
					break;
			}
		}
		seconds.forEach(item => {
			item.textContent = description
		})
	},
	setDifferentMinutesDescription: function (CurMinutes) {
		let minutes = document.querySelectorAll('.discount-times-minutes');
		if (!minutes.length) return false;
		let description = '';
		if (+CurMinutes > 20) {
			let lastSymbol = CurMinutes.toString().slice(-1);
			switch (lastSymbol) {
				case '1':
					description = 'минута';
					break;
				case '2':
				case '3':
				case '4':
					description = 'минуты';
					break;
				default:
					description = 'минут';
					break;
			}

		} else {
			switch (CurMinutes) {
				case 1:
					description = 'минута';
					break;
				case 2:
				case 3:
				case 4:
					description = 'минуты';
					break;
				default:
					description = 'минут';
					break;
			}
		}
		minutes.forEach(item => {
			item.textContent = description
		})
	},
	setDifferentHoursDescription: function (CurHours) {
		let hours = document.querySelectorAll('.discount-times-hours');
		if (!hours.length) return false;
		let description = '';
		if (+CurHours > 20) {
			let lastSymbol = CurHours.toString().slice(-1);
			switch (lastSymbol) {
				case '1':
					description = 'час';
					break;
				case '2':
				case '3':
				case '4':
					description = 'часа';
					break;
				default:
					description = 'часов';
					break;
			}

		} else {
			switch (CurHours) {
				case 1:
					description = 'час';
					break;
				case 2:
				case 3:
				case 4:
					description = 'часа';
					break;
				default:
					description = 'часов';
					break;
			}
		}
		hours.forEach(item => {
			item.textContent = description
		})
	},
	setDifferentDaysDescription: function (CurDays) {
		let days = document.querySelectorAll('.discount-times-days');
		if (!days.length) return false;
		let description = '';
		if (+CurDays > 20) {
			let lastSymbol = CurDays.toString().slice(-1);
			switch (lastSymbol) {
				case '1':
					description = 'день';
					break;
				case '2':
				case '3':
				case '4':
					description = 'дня';
					break;
				default:
					description = 'дней';
					break;
			}

		} else {
			switch (CurDays) {
				case 1:
					description = 'день';
					break;
				case 2:
				case 3:
				case 4:
					description = 'дня';
					break;
				default:
					description = 'дней';
					break;
			}
		}
		days.forEach(item => {
			item.textContent = description
		})
	},
	init: function () {
		if (this.getDiscountTime()) {
			setInterval(() => {
				this.setDifferentTime()
			}, 1000)
		}

	}
};

window.k1DiscountTime.init();